import { FormValidationRule } from "../types";

const isEmpty = (value: any) => {
    switch (true) {
        case value === undefined || value === null:
            return true;
        case value instanceof File: // file
            return false;
        case typeof value === "string" && value.trim().length === 0:
            return true;
        case value.length === 0: // empty array (selects)
            return true;
        case value === Object(value) && Object.keys(value).length === 0: // empty objects (checkboxes)
            return true;
        default:
            return false;
    }
};

const isRequired: FormValidationRule = (c, v) => {
    // const minimumSelection = parseInt(
    //     c.form_field_tab_boi_selectable_checkbox_min ?? ""
    // );
    // if (c.type === "checkbox" && minimumSelection >= 1) {
    //     return [true, ""];
    // }
    return [
        !c.isRequired || !isEmpty(v),
        c.errorMessage ||
            (c.label ? `The "${c.label}" field is required.` : "Required field.")
    ];
};

export default isRequired;
